import React, { useState } from 'react'
import Modal from '../../../components/Modal'

export default function PendingWorkLogRequests({ pendingRequests = [], onResolve, loading = false }) {
  const [resolvingId, setResolvingId] = useState(null)
  const [rejectingReq, setRejectingReq] = useState(null)
  const [rejectionReason, setRejectionReason] = useState('')
  const [conflictData, setConflictData] = useState(null)

  if (!pendingRequests || pendingRequests.length === 0) {
    return null
  }

  const handleApprove = async (reqId) => {
    setResolvingId(reqId)
    try {
      const res = await onResolve(reqId, true)
      if (res && res.code === 'DATA_CONFLICT') {
        setConflictData(res.details)
      }
    } catch (err) {
      if (err?.code === 'DATA_CONFLICT' || err?.status === 409) {
        setConflictData(err.details || err.data?.details)
      }
    } finally {
      setResolvingId(null)
    }
  }

  const handleConfirmReject = async () => {
    if (!rejectingReq) return
    setResolvingId(rejectingReq.id)
    try {
      await onResolve(rejectingReq.id, false, rejectionReason)
      setRejectingReq(null)
      setRejectionReason('')
    } finally {
      setResolvingId(null)
    }
  }

  const formatType = (type) => {
    if (type === 'acceptance') return 'Приёмка'
    if (type === 'issued') return 'Выдача'
    if (type === 'returns') return 'Возврат'
    return type
  }

  const renderDiff = (oldData, requestedData) => {
    const changes = []
    const fieldLabels = {
      count: 'Вовремя (шт)',
      count_late: 'С опозданием (шт)',
      box_number: 'Коробка',
      comment: 'Заметка',
      start_time: 'Начало',
      end_time: 'Конец'
    }

    Object.keys(fieldLabels).forEach(key => {
      const oldVal = oldData?.[key] !== undefined && oldData?.[key] !== null ? oldData[key] : '—'
      const reqVal = requestedData?.[key] !== undefined && requestedData?.[key] !== null ? requestedData[key] : '—'
      if (String(oldVal) !== String(reqVal)) {
        changes.push({
          label: fieldLabels[key],
          oldVal,
          reqVal
        })
      }
    })

    if (changes.length === 0) return <span style={{ color: 'var(--text-tertiary)' }}>Без изменений</span>

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {changes.map((ch, idx) => (
          <div key={idx} style={{ fontSize: '13px' }}>
            <span style={{ fontWeight: 600 }}>{ch.label}: </span>
            <span style={{ textDecoration: 'line-through', color: 'var(--danger)', marginRight: '6px' }}>{ch.oldVal}</span>
            <span style={{ color: 'var(--text-tertiary)', marginRight: '6px' }}>→</span>
            <span style={{ fontWeight: 700, color: 'var(--success)' }}>{ch.reqVal}</span>
          </div>
        ))}
      </div>
    )
  }

  return (
    <>
      <div 
        className="card" 
        style={{ 
          marginBottom: '16px', 
          border: '1px solid rgba(245, 158, 11, 0.4)',
          background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.05), rgba(203, 17, 171, 0.03))'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '18px' }}>⚠️</span>
            <span style={{ fontWeight: 700, fontSize: '15px', color: 'var(--warning-dark, #b45309)' }}>
              Запросы на исправление смен ({pendingRequests.length})
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {pendingRequests.map(req => (
            <div 
              key={req.id} 
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--surface-border)',
                borderRadius: '12px',
                padding: '12px 14px'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '14px' }}>
                    {req.requested_by_name || 'Сотрудник'}
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>
                    Дата смены: <strong>{req.work_date}</strong> ({formatType(req.work_log_type)}) • ПВЗ: {req.pvz_name}
                  </div>
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', whiteSpace: 'nowrap' }}>
                  {new Date(req.created_at).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>

              <div style={{ marginBottom: '8px', padding: '8px 10px', background: 'var(--bg-secondary)', borderRadius: '8px' }}>
                {renderDiff(req.old_data, req.requested_data)}
              </div>

              <div style={{ fontSize: '13px', fontStyle: 'italic', color: 'var(--text-secondary)', marginBottom: '12px' }}>
                «Причина: {req.reason}»
              </div>

              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ flex: 1, padding: '8px 12px', fontSize: '13px', background: '#10b981', borderColor: '#10b981' }}
                  disabled={resolvingId === req.id}
                  onClick={() => handleApprove(req.id)}
                >
                  {resolvingId === req.id ? 'Обработка...' : 'Одобрить'}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ flex: 1, padding: '8px 12px', fontSize: '13px', color: 'var(--danger)', borderColor: 'rgba(239,68,68,0.3)' }}
                  disabled={resolvingId === req.id}
                  onClick={() => { setRejectingReq(req); setRejectionReason('') }}
                >
                  Отклонить
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Модалка отклонения */}
      <Modal
        isOpen={Boolean(rejectingReq)}
        onClose={() => setRejectingReq(null)}
        title="Отклонить запрос на исправление"
        isBottomSheet={true}
        onConfirm={handleConfirmReject}
      >
        <div style={{ padding: '8px 0 16px' }}>
          <div style={{ fontSize: '14px', marginBottom: '12px', color: 'var(--text-secondary)' }}>
            Вы отклоняете запрос от {rejectingReq?.requested_by_name} (смена {rejectingReq?.work_date}).
          </div>
          <div className="input-group">
            <label>Причина отклонения (необязательно)</label>
            <input
              className="input"
              type="text"
              placeholder="Укажите комментарий для сотрудника..."
              value={rejectionReason}
              onChange={e => setRejectionReason(e.target.value)}
            />
          </div>
        </div>
        <div style={{ display: 'flex', gap: '10px', marginTop: '12px' }}>
          <button type="button" className="btn btn-secondary" style={{ flex: 1 }} onClick={() => setRejectingReq(null)}>
            Отмена
          </button>
          <button type="button" className="btn btn-danger" style={{ flex: 1 }} onClick={handleConfirmReject}>
            Подтвердить отклонение
          </button>
        </div>
      </Modal>

      {/* Модалка конфликта данных */}
      <Modal
        isOpen={Boolean(conflictData)}
        onClose={() => setConflictData(null)}
        title="⚠️ Данные изменились после запроса"
        isBottomSheet={true}
      >
        <div style={{ padding: '8px 0 16px', color: 'var(--text-secondary)' }}>
          <p style={{ marginBottom: '12px', color: 'var(--danger)', fontWeight: 600 }}>
            Исходная запись в базе данных была изменена кем-то после подачи этого запроса! Автоматическое применение заблокировано.
          </p>

          {conflictData && (
            <div style={{ fontSize: '13px', background: 'var(--bg-secondary)', padding: '12px', borderRadius: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <div><strong>Было при создании запроса:</strong> {JSON.stringify(conflictData.old_at_request)}</div>
              <div><strong>Сейчас в базе данных:</strong> {JSON.stringify(conflictData.current_in_db)}</div>
              <div><strong>Запросил сотрудник:</strong> {JSON.stringify(conflictData.requested_by_employee)}</div>
            </div>
          )}
        </div>
        <div style={{ marginTop: '16px' }}>
          <button type="button" className="btn btn-primary" style={{ width: '100%' }} onClick={() => setConflictData(null)}>
            Понятно
          </button>
        </div>
      </Modal>
    </>
  )
}
